module.exports = __webpack_public_path__ + "images/people/support-team@2x-8e79df7787a73b104b51911af894763b.webp";